import React from 'react'
import Select, { components, SingleValue } from 'react-select'
import Icon from '../../icon'
import { t } from '../../../../i18n'
import { FilterOption } from '../types'

interface SelectFilterProps {
  inputId: string
  label: string
  value: string
  options: FilterOption[]
  onChange: (value: string) => void
}

const SelectFilter: React.FC<SelectFilterProps> = ({
  inputId,
  label,
  value,
  options,
  onChange
}) => {
  const anyOption: FilterOption = {
    value: '',
    label: t('any', { scope: 'table_filters' })
  }
  const selectOptions = [anyOption, ...options]

  return (
    <div>
      <label className="form-label" htmlFor={inputId}>
        {label}
      </label>
      <Select
        inputId={inputId}
        className="react-select"
        classNamePrefix="react-select"
        value={
          selectOptions.find((option) => option.value === value) ?? anyOption
        }
        onChange={(option: SingleValue<FilterOption>) =>
          onChange(option?.value ?? '')
        }
        options={selectOptions}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: (dropdownProps) => (
            <components.DropdownIndicator {...dropdownProps}>
              <Icon name="arrowDown" />
            </components.DropdownIndicator>
          )
        }}
      />
    </div>
  )
}

export default SelectFilter
